<script setup lang="ts">
import DrawerHeader from './DrawerHeader/index.vue'
import { useAdsStatusQuery } from '~~/src/composables/query/ads/getAdsStatusQuery'
import { useLeftSidebarStore } from '~~/src/stores/leftSidebar'
const AppPubBanner = defineAsyncComponent(() => import('@/components/App/PubBanner/index.vue'))
defineOptions({
  name: 'DrawerLeft',
})

const state = useLeftSidebarStore()
const { data } = useAdsStatusQuery()
useEventListener('keydown', (event) => {
  if (event.key === '\\' && event.altKey)
    state.toggleSidebar()
})
</script>

<template>
  <div class="flex items-stretch max-h-full h-full overflow-y-hidden isolate">
    <div
      class="drawer__wrapper"
      :aria-expanded="state.isOpen"
    >
      <div
        class="flex flex-col justify-center h-full"
      >
        <div
          class="hidden md:flex flex-col justify-center items-center w-15 pt-3 p-3.5"
        >
          <DrawerHeader />
        </div>

        <div
          :aria-expanded="state.isOpen"
          class="drawer__container flex flex-col justify-between gap-5 max-h-full h-full overflow-x-hidden bg-white"
        >
          <div
            class="drawer__no-scrollbar flex flex-col"
          >
            <template v-if="$slots.default">
              <slot />
            </template>
          </div>
          <div
            v-if="state.isOpen"
            class="p-3.5"
          >
            <AppPubBanner v-if="data?.['rectangle-banner']" type="rectangle-banner" />
          </div>
        </div>
      </div>
    </div>

    <div
      class="relative  border-l-softGray border-l-1 border-l-darkGray border-l-softGray"
    />
  </div>
</template>

<style lang="scss" scoped>
.drawer__wrapper {
  @apply  flex flex-col min-h-full bg-white z-2
      items-stretch
      max-h-full
      h-full
      overflow-hidden
      ;

  &[aria-expanded='true'] {
    @apply overflow-x-auto;
    width: 17.5rem; /** fixed width */
  }

  &[aria-expanded='false'] {
    @apply w-15 #{!important};
    @apply sm:translate-x-0;

  }
  @apply w-15 overflow-x-hidden;

  &::-webkit-scrollbar {
    display: none;
  }

  transition: width 0.3s ease-out;

  @media screen and (max-width: 768px) {
    &[aria-expanded='true'] {
      width: 100%;
    }
  }
}

.drawer__container{
  @apply translate-x-0;
  transition: transform 0.4s ease-out;
}

.drawer__no-scrollbar{
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
